import { InjectionToken } from '@angular/core';

const APP_ENV_KEYS = ['local', 'test', 'beta', 'dev', 'pre', 'prod'] as const;
export type EnvironmentKey = (typeof APP_ENV_KEYS)[number];

export function isEnvironmentKey(item: unknown): item is EnvironmentKey {
  return !!item && APP_ENV_KEYS.includes(item as EnvironmentKey);
}

export const APP_ENV_CONFIG_TOKEN = new InjectionToken<AppEnvConfig>('AppEnvConfig');

/**
 * Main application base url
 */
export const APP_BASE_URL_TOKEN = new InjectionToken<string>('AppBaseUrl');

/**
 * @param cacheBusterTimestamp - A timestamp generated on each build to prevent browser caching issue
 */
export interface AppEnvConfig {
  production: boolean;
  cacheBusterTimestamp: number;
  environmentKey: EnvironmentKey;
  apiRootUrls: Record<EnvironmentKey, string> | null;
}
